import React from "react";
import { Box, Alert } from "@mui/material";
import { usePermissions } from "../hooks/usePermissions";

/** Gates a page behind one or more usePermissions() flags, e.g. allow={["isAdmin", "isManagement"]}. */
export default function RequireRole({ allow, children }) {
    const permissions = usePermissions();
    const hasAccess = allow.some((key) => permissions[key]);

    if (!hasAccess) {
        return (
            <Box sx={{ mt: 4 }}>
                <Alert severity="warning">
                    You don't have access to this page.
                </Alert>
            </Box>
        );
    }

    return children;
}
